export const ANON_REQUEST_COUNTS_KEY = 'sonmi_registration_completed_requests_v1';
export const NEXT_SAVE_PROMPT_KEY = 'sonmi_registration_next_save_prompt_v1';
const PREVIOUS_SOFT_PROMPT_KEY = 'sonmi_registration_soft_prompt_seen_v2';
const SAVE_PROMPT_INTERVAL = 5;

export function readNextSavePromptAt(storage = window.localStorage) {
  try {
    const saved = Number(storage.getItem(NEXT_SAVE_PROMPT_KEY));
    if (Number.isInteger(saved) && saved >= SAVE_PROMPT_INTERVAL) return saved;
    // Guests who already saw the old one-time prompt should first see a repeat
    // after their tenth answer, rather than another prompt immediately.
    if (storage.getItem(PREVIOUS_SOFT_PROMPT_KEY) === 'true') return 10;
  } catch {}
  return SAVE_PROMPT_INTERVAL;
}

export function nextSavePromptAfter(completed) {
  return completed + SAVE_PROMPT_INTERVAL;
}

export function readAnonymousRequestCounts(storage = window.localStorage) {
  try {
    const parsed = JSON.parse(storage.getItem(ANON_REQUEST_COUNTS_KEY) || '{}');
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return Object.fromEntries(
      Object.entries(parsed).filter(([sessionId, count]) => sessionId && Number.isFinite(count) && count >= 0)
    );
  } catch {
    return {};
  }
}

// Keep the highest completed-answer count seen for each conversation. Reloading
// or switching back to an old conversation cannot count it twice, while totals
// still accumulate across every conversation on this device.
export function recordAnonymousRequestCount(sessionId, completed, storage = window.localStorage) {
  if (!sessionId || !Number.isFinite(completed) || completed < 0) return 0;
  const counts = readAnonymousRequestCounts(storage);
  counts[sessionId] = Math.max(Number(counts[sessionId]) || 0, completed);
  try { storage.setItem(ANON_REQUEST_COUNTS_KEY, JSON.stringify(counts)); } catch {}
  return Object.values(counts).reduce((total, count) => total + (Number(count) || 0), 0);
}
